import React from 'react';

import './styles.css';

const Receipt = ({receipt, toPrint}) => {
  if (!receipt) return null;
  if (receipt.text) {
    return (
      <div className={`receipt receipt-text ${toPrint && 'receipt-printable'}`}>
        {receipt.text.split('\n').map((line, index) => (
          <div key={index} className="receipt-line">
            {line}
          </div>
        ))}
      </div>
    )
  }
  if (receipt.html) {
    return (
      <div className={`receipt ${toPrint && 'receipt-printable'}`}
           dangerouslySetInnerHTML={{__html: receipt.html}}/>
    );
  }
  return null;
};

export default Receipt;
